import { useContext, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { accountAccessShowLogin, modalClose } from 'actions/UiActions'
import { hasPassedWalledGarden } from 'selectors/accountSelectors'
import { EUROPE_REGIONS } from 'constants/config/region'
import { isInMobileApp } from 'lib/web/deviceUtils'
import GeoContext from 'contexts/geoContext'

const walledRegions = new Set([
  ...EUROPE_REGIONS.values(),
  'AU',
  'NZ',
])

function useOfferPageWalledGarden() {
  const dispatch = useAppDispatch()
  const { currentRegionCode } = useContext(GeoContext)
  const utmMedium = useAppSelector(state => state.utm.medium)
  const isMobileApp = useAppSelector(state => isInMobileApp(state.config.rawUserAgentString))

  const isWallGardened = walledRegions.has(currentRegionCode)
  const bypassWalledGarden = isMobileApp ||
    utmMedium === 'email' ||
    utmMedium === 'push' ||
    utmMedium === 'sms'

  const passedWalledGarden = useAppSelector(hasPassedWalledGarden)

  const showWall = isWallGardened && !(bypassWalledGarden || passedWalledGarden)

  useEffect(() => {
    if (showWall) {
      dispatch(accountAccessShowLogin('login', false))
      return () => {
        dispatch(modalClose())
      }
    }
  }, [dispatch, showWall])
}

export default useOfferPageWalledGarden
